import { apiFetch } from './api';
import { authService } from './login';

export function logOutUser() {
    return Promise.allSettled([authService.getSsoUrls(), apiFetch('account/logout')]).then(
        /**
         * @param {[PromiseSettledResult<import('./login').SsoUrls>]}
         */
        ([urls]) => {
            //Delete auth values and remove login redirect URL
            authService.clearAuthentication();
            localStorage.setItem('loginRedirect', '');

            if (urls.status === 'fulfilled' && urls.value?.logout) location.assign(urls.value.logout);
            else {
                //Redirect to login page
                var currentUrl = window.location.href;
                var redirectUrl = currentUrl.substring(0, currentUrl.lastIndexOf("/"));
                redirectUrl += "/login.html";
                window.location.href = redirectUrl;
            }
        }
    )
}
